import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { FeatureModulesService, ScriptLoader } from '@spartacus/core';
import { SMART_EDIT_FEATURE, SmartEditConfig } from '@spartacus/smartedit/root';

/**
 * The CustomSmartEditLauncherService is used to check whether Spartacus is launched inside Smart Edit;
 * it also gets cmsTicketId sent from Smart Edit.
 */
@Injectable({
  providedIn: 'root',
})
export class CustomSmartEditLauncherService {
  protected readonly featureModulesService = inject(FeatureModulesService);
  private _cmsTicketId: string | undefined;

  get cmsTicketId(): string | undefined {
    return this._cmsTicketId;
  }

  constructor(
    protected config: SmartEditConfig,
    protected location: Location,
    protected scriptLoader: ScriptLoader
  ) {

  }

  /**
   * load webApplicationInjector.js first when Spartacus launched inside SmartEdit
   */
  load(): void {
    if (this.isLaunchedInSmartEdit()) {
      this.featureModulesService.resolveFeature(SMART_EDIT_FEATURE).subscribe();

      this.scriptLoader?.embedScript({
        src: 'webApplicationInjector.js',
        params: undefined,
        attributes: {
          id: 'text/smartedit-injector',
          'data-smartedit-allow-origin': this.config.smartEdit?.allowOrigin,
        },
      });
    }
  }

  /**
    * Indicates whether Spartacus is launched in SmartEdit
    */
  isLaunchedInSmartEdit(): boolean {
    const path = this.location.path().split('?')[0];
    const params = this.location.path().split('?')[1];
    const cmsToken = params
      ?.split('&')
      .find((param) => param.startsWith('cmsTicketId='));

    const newCmsTicketId = cmsToken?.split('=')[1];

    if (newCmsTicketId) {
      // Update local storage if a new cmsTicketId is present in the URLif (newCmsTicketId !== localStorage.getItem('cmsTicketId')) {
      localStorage.setItem('cmsTicketId', newCmsTicketId);
      this._cmsTicketId = newCmsTicketId;
    } else {
      // Retrieve cmsTicketId from local storage if not present in the URL
      this._cmsTicketId = localStorage.getItem('cmsTicketId') || undefined;
    }
    return (
      path.split('/').pop() === this.config.smartEdit?.storefrontPreviewRoute &&
      !!this._cmsTicketId
    );
  }

}
